<div class="email-confirmation-dialog p-6">
  <h2 class="text-xl font-bold mb-4 text-center">Conferma invio email</h2>

  <div class="email-counter-container flex justify-center mb-6">
    <div class="email-counter-box bg-gray-100 rounded-lg p-6 text-center w-full">
      <div class="icon-container flex justify-center mb-4">
        <fa-icon [icon]="faEnvelope" class="text-5xl text-blue-500"></fa-icon>
      </div>

      <div class="counter-stats flex justify-center items-center gap-8 w-full">
        <div class="counter-item flex-1 text-center text-green-500">
          <div class="counter-value text-3xl font-bold">{{ data.countDaInviareValid }}</div>
          <div class="counter-label text-sm">Email da inviare</div>
        </div>
        <div class="counter-item flex-1 text-center text-orange-500">
          <div class="counter-value text-3xl font-bold">{{ data.countDaInviareInvalid }}</div>
          <div class="counter-label text-sm">Email con dati invalidi</div>
        </div>
        <div class="counter-item flex-1 text-center text-red-500">
          <div class="counter-value text-3xl font-bold">{{ data.countDaNonInviare }}</div>
          <div class="counter-label text-sm">Email da non inviare</div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="data.countDaInviareValid === 0"
    class="alert-no-emails bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-6 rounded"
  >
    <div class="flex items-center">
      <div class="py-1">
        <fa-icon [icon]="faWarning" class="text-yellow-500 mr-3"></fa-icon>
      </div>
      <div>
        <p class="font-medium text-yellow-700">Attenzione</p>
        <p class="text-sm text-yellow-600">Non ci sono email da inviare.</p>
      </div>
    </div>
  </div>

  <div class="confirmation-text text-center mb-6">
    <p>Confermi di voler procedere con l'invio delle email?</p>
  </div>

  <div class="actions flex justify-center gap-4">
    <button
      (click)="onConfirm()"
      [disabled]="data.countDaInviareValid === 0"
      class="px-6 py-2"
      color="primary"
      mat-raised-button
    >
      Conferma
    </button>
    <button (click)="onCancel()" class="px-6 py-2" color="warn" mat-raised-button>Annulla</button>
  </div>
</div>
